import React, { createContext, useContext, useState, useEffect } from 'react'
import axios from 'axios'

const AuthContext = createContext()

export const useAuth = () => {
  const context = useContext(AuthContext)
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider')
  }
  return context
}

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null)
  const [loading, setLoading] = useState(true)
  const [token, setToken] = useState(localStorage.getItem('token'))

  useEffect(() => {
    if (token) {
      checkAuth()
    } else {
      setLoading(false)
    }
    // checkAuth reads only `token`, which is listed. It is recreated every
    // render, so listing it would re-run /me on every render.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token])

  const checkAuth = async () => {
    try {
      const response = await axios.get('https://api.cityseecityfix.com/api/v1/me', {
        headers: { Authorization: `Bearer ${token}` }
      })
      setUser(response.data)
    } catch (error) {
      console.error('Auth check failed:', error)
      logout()
    } finally {
      setLoading(false)
    }
  }

  const login = async (email, password) => {
    try {
      // Create FormData object for form submission
      const formData = new FormData()
      formData.append('email', email)
      formData.append('password', password)
      
      const response = await axios.post('https://api.cityseecityfix.com/api/v1/login', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      const { access_token, user: userData } = response.data
      setToken(access_token)
      setUser(userData)
      localStorage.setItem('token', access_token)
      return { success: true }
    } catch (error) {
      console.error('Login failed:', error)
      return { success: false, error: error.response?.data?.detail || 'Login failed' }
    }
  }

  const logout = () => {
    setUser(null)
    setToken(null)
    localStorage.removeItem('token')
  }

  const value = {
    user,
    loading,
    login,
    logout,
    isAuthenticated: !!user,
    token
  }

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  )
}
